// extracted by mini-css-extract-plugin
export default {"wrapper":"User-module__wrapper","loginPopupParent":"User-module__loginPopupParent","loginPopup":"User-module__loginPopup"};